module.exports = __webpack_public_path__ + "img/2.da847906.png";